import React from 'react';
import ErrorPage from 'pages/errorPage';
import { trace } from 'api';
import { readFromStore } from 'storage';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  // handle unhandled errors from async
  // return if hasError is already true to avoid infinite looping
  componentDidMount() {
    window.onunhandledrejection = (evt) => {
      if (this.state.hasError) return;
      this.setState({ hasError: true });
      console.error('onunhandledrejection', evt);
      this.safeTrace(readFromStore('login'), evt.reason);
    };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    // logErrorToMyService(error, errorInfo);
    console.error('ErrorBoundary', error, errorInfo);
    this.safeTrace(readFromStore('login'), error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return <ErrorPage />;
    }

    return this.props.children;
  }

  safeTrace(login, message, messageDetail) {
    try {
      trace(login, message, messageDetail);
    } catch (error) {
      console.error(error);
    }
  }
}

export { ErrorBoundary };
